<div class="new-content" *ngIf="!pane || !pane.loaded else contentBlock">
  <loading-line height="40px" width="100%"></loading-line>
</div>
<ng-template #contentBlock>
  <ng-template [ngIf]="content.length" [ngIfElse]="empty">
    <div class="pane-header" [class.mobile]="deviceService.isMobile()">
    <app-library-title [title]="blockTitle" [class.with-sorting]="_pane.show_sorting"></app-library-title>
    <app-library-sorting *ngIf="_pane.show_sorting" [class.with-more]="blockTitle?.see_all_link" [pane]="_pane"></app-library-sorting>
    </div>

    <div *ngFor="let item of content; trackBy: trackByFn" class="content-item">
      <app-content-card [item]="item"></app-content-card>
    </div>
  </ng-template>

  <ng-template #empty>
    <app-no-content-stub
      [icon]="'stub-comments'"
      [text]="'comments.stub'">
    </app-no-content-stub>
  </ng-template>
</ng-template>
